import React, { useState } from 'react';
import { FaTimes, FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import '../css/lightbox.css';

export default function LightboxGallery({ images }) {
  const [isOpen, setOpen] = useState(false);
  const [idx, setIdx] = useState(0);

  const prevImage = (e) => {
    e.stopPropagation();
    setIdx((prev) => (prev === 0 ? images.length - 1 : prev - 1));
  };

  const nextImage = (e) => {
    e.stopPropagation();
    setIdx((prev) => (prev === images.length - 1 ? 0 : prev + 1));
  };

  return (
    <>
      <div className="thumbs">
        {images.map((src, i) => (
          <img
            key={i}
            src={src}
            alt=""
            onClick={() => { setIdx(i); setOpen(true); }}
            className="thumb"
          />
        ))}
      </div>

      {isOpen && (
        <div className="lightbox" onClick={() => setOpen(false)}>
          <button className="close-btn" onClick={() => setOpen(false)}>
            <FaTimes size={20} />
          </button>
          <button className="nav-btn prev" onClick={prevImage}>
            <FaChevronLeft size={30} />
          </button>
          <img src={images[idx]} alt="" className="lightbox-img" />
          <button className="nav-btn next" onClick={nextImage}>
            <FaChevronRight size={30} />
          </button>
        </div>
      )}
    </>
  );
}